import axios from 'axios'
import React, {useContext} from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../context/UserContext'
import '../misc/Navbar.scss'
import domain from '../../util/domain'

const Navbar = () => {
    const {user, getUser} = useContext(UserContext)
    const logOut = async () => {
        await axios.get(`${domain}/auth/logout`);
        await getUser();
    }
    return (
        <div className ='navbar'>
        <div className='left-side'>
            <Link to='/'>
                <h1>Snippet List</h1>
            </Link>
            </div>
            {!user ? (<div className='right-side'>
            <Link to='/login'>
                Login
            </Link>
            <Link to='/register'>
                Register
            </Link>
            </div>) : <button className="btn-log-out" onClick={logOut}>Log out</button>}
        </div>
    )
}

export default Navbar
